import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Escandallo/filtrarEscandallo`, method: 'POST', body: values, token: token})
}